export default __webpack_public_path__ + "static/media/turbina.c2d25f7e.svg";